

class OutbuildingItem {
	constructor() {
		this.parentProperty = null;
		this.propertyIndex = 0; // 0 - Subject, 1+ - comparable PropertyOrdinalNumber
		this.outbuildingIndex = 0;
		this.row = 0; // occurrence within same property 0, 1, etc.
		this.type = '';
		this.livingUnitCount = 0;
		this.comparableAmount = '';

		this.grossBuildingArea = '';
		this.finishedArea = '';
		this.unfinishedArea = '';
		this.structureVolume = '';
		this.bathsFull = '';
		this.bathsHalf = '';
		this.kitchens = '';
		this.heating = '';
		this.cooling = '';
		this.utilities = '';
	}
}

// Get the maximum number of outbuildings for the subject property
function GetMaxSubjOutbuildings() {
	let maxOutbuildings = 0;
	for (const i of global.ptr.subProp.improvements.improvementList) {
		if (i.improvementDetail.improvementType === "Outbuilding" && i.improvementDetail.outbuildingType !== "StandaloneADU") {
			maxOutbuildings++;
		}
	}
	return maxOutbuildings;
}

// Get the maximum number of outbuildings among all comparables
function GetMaxCompOutbuildings() {
	let maxOutbuildings = 0;
	for (const cp of global.ptr.compList) {
		let count = 0;
		for (const i of cp.improvements.improvementList) {
			if (i.improvementDetail.improvementType === "Outbuilding" && i.improvementDetail.outbuildingType !== "StandaloneADU") {
				count++;
			}
		}
		if (count > maxOutbuildings) {
			maxOutbuildings = count;
		}
	}
	return maxOutbuildings;
}

// Get a list of outbuildings for a specific index
function GetOutbuildingsList(index) {
	const list = [];
	list.push(global.ptr.subProp.GetOutbuilding(index));
	for (const cp of global.ptr.compList) {
		list.push(cp.GetOutbuilding(index));
	}
	return list;
}

// Get detailed information about an outbuilding
function GetOutbuildingInfo(i) {
	const ob = new OutbuildingItem();
	ob.type = i.GetOutbuildingType();
	ob.livingUnitCount = Number(i.structure?.structureDetail.livingUnitCount);

	ob.grossBuildingArea = i.structure?.structureDetail.structureAreaMeasure.ToString();
	ob.finishedArea = i.structure?.structureDetail.structureExcludingVehicleStorageAndADUFinishedAreaMeasure.ToString();
	ob.unfinishedArea = i.structure?.structureDetail.structureExcludingVehicleStorageAndADUUnfinishedAreaMeasure.ToString();
	ob.structureVolume = i.structure?.structureDetail.structureVolumeMeasure.ToString();
	ob.bathsFull = i.GetInteriorSummaryRoomCount("FullBathroom");
	ob.bathsHalf = i.GetInteriorSummaryRoomCount("HalfBathroom");
	ob.kitchens = i.GetKitchenCount().toString();
	ob.heatingExists = i.GetHeatingExistsIndicator();
	ob.heatingTypes = i.GetHeatingTypes();
	ob.coolingExists = i.GetCoolingExistsIndicator();
	ob.coolingTypes = i.GetCoolingTypes();
	ob.utilities = i.outbuilding?.GetUtilities() || '';
	return ob;
}

// Get a list of detailed information about all outbuildings
function GetOutbuildingsInfoList() {
	const list = [];
	let rowIndex = 0;

	// Process subject property outbuildings
	for (const i of global.ptr.subProp.improvements.improvementList) {
		if (i.improvementDetail.improvementType === "Outbuilding") {
			if (i.improvementDetail.outbuildingType !== "StandaloneADU") {
				const ob = GetOutbuildingInfo(i);
				ob.parentProperty = global.ptr.subProp;
				ob.propertyIndex = 0;
				ob.row = rowIndex++;
				if (global.ptr.subProp.comparable !== null) {
					ob.comparableAmount = global.ptr.subProp.comparable.GetComparableAdjustmentAmount("Outbuilding");
				}
				list.push(ob);
			}
		}
	}

	// Process comparable properties outbuildings
	for (const cp of global.ptr.compList) {
		rowIndex = 0;
		for (const i of cp.improvements.improvementList) {
			if (i.improvementDetail.improvementType === "Outbuilding") {
				if (i.improvementDetail.outbuildingType !== "StandaloneADU") {
					const ob = GetOutbuildingInfo(i);
					ob.row = rowIndex++;
					ob.propertyIndex = Number(cp.comparable.comparableDetail.propertyOrdinalNumber);
					ob.parentProperty = cp;
					ob.comparableAmount = cp.comparable.GetComparableAdjustmentAmount("Outbuilding");
					list.push(ob);
				}
			}
		}
	}

	return list;
}

// Function to Get an outbuilding item by property index and row
function GetOutbuildingItem(outBuildings, comp, row) {
	for (const oi of outBuildings) {
		if (oi.propertyIndex === comp && oi.row === row) {
			return oi;
		}
	}
	return null;
}

// Function to Get outbuilding types
function GetOutbuildingTypes(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("!Outbuilding Type");


	const oi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(toDashesIfEmpty(oi?.type));

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		let row1 = [];
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (!oi) {
			row1.push("--");
			row1.push("");
		} else {
			row1.push(oi.type);
			row1.push(oi.comparableAmount.ToDollarAmount());
		}
		list.push(row1);
	}
	return list;
}

// Function to Get outbuilding gross building area
function GetOutbuildingGrossBuildingArea(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Gross Building Area")

	let haveData = false;
	const oi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(toDashesIfEmpty(oi?.grossBuildingArea));

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi && oi.grossBuildingArea) haveData = true;
		list.push(toDashesIfEmpty(oi?.grossBuildingArea));
	}

	if (!haveData) return [];
	return list;
}

// Function to Get outbuilding finished area
function GetOutbuildingFinishedArea(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Finished Area")

	let haveData = false;
	const oi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(toDashesIfEmpty(oi?.finishedArea));

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi && oi.finishedArea) haveData = true;
		list.push(toDashesIfEmpty(oi?.finishedArea));
	}

	if (!haveData) return [];
	return list;
}

// Function to Get outbuilding unfinished area
function GetOutbuildingUnfinishedArea(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Unfinished Area")

	let haveData = false;
	const oi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(toDashesIfEmpty(oi?.unfinishedArea));

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi && oi.unfinishedArea) haveData = true;
		list.push(toDashesIfEmpty(oi?.unfinishedArea));
	}

	if (!haveData) return [];
	return list;
}

// Function to Get outbuilding structure volume
function GetOutbuildingStructureVolume(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Stricture Volume")

	let haveData = false;
	const oi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(toDashesIfEmpty(oi?.structureVolume));

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi && oi.structureVolume) haveData = true;
		list.push(toDashesIfEmpty(oi?.structureVolume));
	}

	if (!haveData) return [];
	return list;
}

// Function to Get outbuilding full baths
function GetOutbuildingBathsFull(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Baths - Full")

	let haveData = false;
	const oi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(toDashesIfEmpty(oi?.bathsFull));

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi && oi.bathsFull) haveData = true;
		list.push(toDashesIfEmpty(oi?.bathsFull));
	}

	if (!haveData) return [];
	return list;
}

// Function to Get outbuilding half baths
function GetOutbuildingBathsHalf(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Baths - Half")

	let haveData = false;
	const soi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(toZeroIfEmpty(soi?.bathsHalf));

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi && oi.bathsHalf) haveData = true;
		list.push(toDashesIfEmpty(oi?.bathsHalf));
	}

	if (!haveData) return [];
	return list;
}

function GetOutbuildingKitchens(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Kitchens")

	let haveData = false;
	const oi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(toDashesIfEmpty(oi?.kitchens));

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi && oi.kitchens && oi.kitchens > 0) haveData = true;
		list.push(toDashesIfEmpty(oi?.kitchens));
	}

	if (!haveData) return [];
	return list;
}

function GetOutbuildingHeating(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Heating")

	let haveData = false;
	const oi = GetOutbuildingItem(outBuildings, 0, row);
	if (oi) {
		if (oi.livingUnitCount > 0)
			list.push(oi.heatingTypes);
		else
			list.push(oi.heatingExists ? "Yes" : "None");
	} else
		list.push("--");

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi) {
			if (oi.heatingExists) {
				list.push("Yes");
				haveData = true;
			} else
				list.push("None");
		} else
			list.push("--");
	}

	if (!haveData) return [];
	return list;
}

function GetOutbuildingCooling(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Cooling")

	let haveData = false;
	const oi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(oi?.cooling ? oi.coolingTypes : "None");

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi) {
			list.push(oi?.cooling ? "Yes" : "None");
			if (oi.coolingExists) haveData = true;
		} else
			list.push("==");
	}

	if (!haveData) return [];
	return list;
}

function GetOutbuildingUtilities(outBuildings, row = 0) {
	const list = [];
	if (!outBuildings) return list;
	list.push("  Utilities");

	let haveData = false;
	const oi = GetOutbuildingItem(outBuildings, 0, row);
	list.push(toDashesIfEmpty(oi?.uUtilities));

	for (let ix = 1; ix <= global.ptr.compCount; ++ix) {
		const oi = GetOutbuildingItem(outBuildings, ix, row);
		if (oi && oi.utilities) haveData = true;
		list.push(toDashesIfEmpty(oi?.utilities));
	}

	if (!haveData) return [];
	return list;
}


function toDashesIfEmpty(value) {
	return value ? value : '--';
}

function toZeroIfEmpty(value) {
	return value ? value : '0';
}


export function GetSalesCompOutbuildingList() {
	let list = [];
	var outList = GetOutbuildingsInfoList();
	//outList = outList.OrderBy(x => x.type).toList();
	
	// reorder subject outbuildings
	var index = 0;
	for(var outItem of outList)
	if (outItem.propertyIndex === 0)
		outItem.row = index++;

	if (outList.length > 0) {
		// get max outbuildings per comp
		// var maxSubOut = global.ptr.valuationAnalysis.GetMaxSubjOutbuildings();
		// var maxCompOut = global.ptr.valuationAnalysis.GetMaxCompOutbuildings();
		// var maxOut = (maxSubOut > maxCompOut) ? maxSubOut : maxCompOut;
		var maxOut = global.ptr.valuationAnalysis.GetMaxOutbuildings();

		for (var row = 0; row < maxOut; row++) {
			list.push(GetOutbuildingTypes(outList, row));
			list.push(GetOutbuildingGrossBuildingArea(outList, row));
			list.push(GetOutbuildingFinishedArea(outList, row));
			list.push(GetOutbuildingUnfinishedArea(outList, row));
			list.push(GetOutbuildingStructureVolume(outList, row));
			list.push(GetOutbuildingBathsFull(outList, row));
			list.push(GetOutbuildingBathsHalf(outList, row));
			list.push(GetOutbuildingKitchens(outList, row));
			list.push(GetOutbuildingHeating(outList, row));
			list.push(GetOutbuildingCooling(outList, row));
			list.push(GetOutbuildingUtilities(outList, row));
		}
	}
	return list;
}
